// extracted by mini-css-extract-plugin
module.exports = {"tableTitle":"CompanyApplicationsPage_tableTitle__ZRSZs","categoryButtons":"CompanyApplicationsPage_categoryButtons__a5MnG"};